import * as React from 'react';
import clsx from 'clsx';
import { isNode } from '../../../dom';
import { Base } from '../../Base';
import Pill from '../../Pill';
import PillsPanel from './PillsPanel';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "hidden": "Pills-hidden_2zW_s",
  "disabled": "Pills-disabled_2SuIv"
};
class Pills extends React.Component {
  disabledItems = (() => new Set())();
  tabs = [];
  panels = [];
  static defaultProps = {
    defaultIndex: 0
  };
  state = {
    selected: this.props.defaultIndex
  };
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.defaultIndex !== nextProps.defaultIndex) {
      this.handleSelect(nextProps.defaultIndex);
    }
  }
  UNSAFE_componentWillUpdate() {
    this.disabledItems.clear();
  }
  renderPill = (child, index) => {
    const tabId = `#pills-tab-${index}`;
    const panelId = `#pills-panel-${index}`;
    const isDisabled = child.props.disabled || this.disabledItems.size + 1 === React.Children.count(this.props.children);
    const isSelected = this.state.selected === index;
    return /*#__PURE__*/_jsx(Base, {
      tagName: "li",
      role: "presentation",
      marginRight: "xsmall",
      children: /*#__PURE__*/_jsx(Pill, {
        tagName: "a",
        id: tabId,
        href: panelId,
        role: "tab",
        "aria-controls": panelId,
        "aria-selected": isSelected,
        tabIndex: isSelected ? 0 : -1,
        selected: isSelected,
        disabled: isDisabled,
        onClick: evt => this.handleClick(evt, index),
        onKeyDown: evt => this.handleKeydown(evt, index),
        className: clsx(styles.pill, isDisabled && styles.disabled),
        refCallback: node => {
          this.tabs[index] = node;
        },
        children: child.props.label
      })
    }, child.props.label);
  };
  renderPills() {
    return /*#__PURE__*/_jsx(Base, {
      tagName: "ul",
      role: "tablist",
      flex: true,
      listStyleType: "none",
      marginTop: "none",
      marginBottom: "small",
      padding: "none",
      className: styles.list,
      children: React.Children.toArray(this.props.children).map(this.renderPill)
    });
  }
  renderPanel = (child, index) => {
    const isHidden = this.state.selected !== index;
    const tabId = `#pills-tab-${index}`;
    const panelId = `#pills-panel-${index}`;
    if (child.props.disabled) {
      this.disabledItems.add(index);
    }
    return /*#__PURE__*/React.cloneElement(child, {
      id: panelId,
      hidden: isHidden,
      role: 'tabpanel',
      'aria-labelledby': tabId,
      'aria-hidden': isHidden,
      refCallback: node => {
        this.panels[index] = node;
      }
    });
  };
  renderPanels() {
    return React.Children.toArray(this.props.children).map(this.renderPanel);
  }
  handleSelect(index, evt) {
    this.focusTab(index);
    this.setState(prevState => {
      if (this.props.handleSelect) {
        this.props.handleSelect(index, prevState.selected, evt);
      }
      return {
        selected: index
      };
    });
  }
  handleClick = (evt, index) => {
    evt.preventDefault();
    this.handleSelect(index, evt);
  };
  handleKeydown = (evt, index) => {
    let direction;
    let newIndex;
    switch (evt.key) {
      case 'ArrowLeft':
        direction = 'left';
        newIndex = index - 1;
        break;
      case 'ArrowRight':
        direction = 'right';
        newIndex = index + 1;
        break;
      case 'ArrowDown':
        direction = 'down';
        break;
      default:
    }
    if (!direction) return;
    evt.preventDefault();
    if (direction === 'down') {
      this.focusPanel(index);
      return;
    }
    if (typeof newIndex === 'number' && this.tabs[newIndex]) {
      this.handleSelect(newIndex, evt);
    }
  };
  focusTab(index) {
    if (isNode(this.tabs[index])) {
      this.tabs[index].focus();
    }
  }
  focusPanel(index) {
    if (isNode(this.panels[index])) {
      this.panels[index].focus();
    }
  }
  render() {
    const {
      defaultIndex,
      children,
      handleSelect,
      ...extraProps
    } = this.props;
    const panels = this.renderPanels();
    const pills = this.renderPills();
    return /*#__PURE__*/_jsxs(Base, {
      ...extraProps,
      children: [pills, panels]
    });
  }
}
export default Pills;